
import * as Lib from "@/lib/functions/plain";
import { Level, Event } from "@/lib/definition/constants";
import { Component, Vue, Watch } from 'vue-property-decorator'
import moment from "moment-timezone";
import Param from "@/lib/definition/variables";
import _ from "lodash"

@Component({
  filters: {
    momentMonth: function(date: any) {
      return moment(date).format("YYYY-MM");
    },
    momentDate: function(date: any) {
      return moment(date).format("YYYY-MM-DD");
    },
    momentDateStd: function(date: any) {
      if (date == null) return "";
      return moment(date).format("YYYY/MM/DD");
    },
    momentDateTime: function(date: any) {
      return moment(date).format("YYYY/MM/DD HH:mm");
    },
    momentDateTimeSecond: function(date: any) {
      return moment(date).format("YYYY/MM/DD HH:mm:ss");
    },
    toLocaleStr: function(v: any) {
      if (v == null) {
        return "";
      }
      return v.toLocaleString();
    }
  }
})
export default class BasicTs extends Vue {
  public site = Param.Site
  get timezone() { return this.$store.direct.state.Timesheet.timezone; }
  get offsetMin() { return this.$store.direct.state.Timesheet.offsetMin; }
  get utctime() { return this.$store.direct.state.Timesheet.utctime; }

  createPageTitle(to: any): any {
    if (to.name) {
      var setTitle = to.name + "｜Koos";
      document.title = setTitle;
    } else {
      document.title = "Koos";
    }
  }
  toggleDrawerMenu () {
    this.$emit('toggle')
  }
  // コンポーネントタグ(テンプレートで定義された文字列)を返します。文字列はアッパーキャメルケースで統一して返されます。
  componentTag() {
    let tag = (this.$options as any)._componentTag;
    return tag ? _.upperFirst(_.camelCase(tag)) : null;
  }
  async masterReady() {

  }
  dispError(message: string) {
    this.$store.direct.dispatch.App.dispError(message);
  }

  dispSuccess(message: string) {
    this.$store.direct.dispatch.App.dispSuccess(message);
  }

  async mounted() {
    var to = this.$route;
    this.createPageTitle(to);
    if (!this.$store.getters["Login/loggedIn"]){
      this.$router.push(this.site.deployFolder + "/loginview")
    } else {
      await this.$store.dispatch('Login/getUserInfo')
      await this.$store.dispatch("Masters/getMastersIfNeeded");
      this.masterReady()
    }
  }
  @Watch('$route')
  onRouteChanged(oldValue: any, newValue: any) {
      this.createPageTitle(newValue);
  }
}
